import { useCallback } from 'react'
import { Button } from '@mui/material'
import { useTheme, CoreTypography } from '@thriveglobal/thrive-web-leafkit'

import { defineMessages, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

const intlMessages = defineMessages({
    navigate: {
        defaultMessage: 'Navigate to {title}',
        description: 'Navigate to - followed by the content title'
    }
})

export type BrowseByTopicButtonProps = {
    id: string
    title: string
    topicUrl?: string
    onClick?: () => void
    sx?: Record<string, any>
}

const BrowseByTopicButton: React.FC<BrowseByTopicButtonProps> = ({
    id,
    title,
    topicUrl,
    onClick,
    sx
}) => {
    const theme = useTheme()
    const history = useHistory()
    const intl = useIntl()

    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick()
        }
        if (topicUrl) {
            history.push(topicUrl)
        }
    }, [onClick, topicUrl, history])

    return (
        <Button
            key={id}
            variant="outlined"
            sx={{
                alignItems: 'center',
                minHeight: theme.spacing(6),
                boxShadow: theme.shadows[9],
                ...sx
            }}
            aria-label={intl.formatMessage(intlMessages.navigate, {
                title
            })}
            onClick={handleOnClick}
        >
            <CoreTypography
                customVariant="buttonNormal"
                sx={{
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                {title}
            </CoreTypography>
        </Button>
    )
}

export default BrowseByTopicButton
